import React from "react";
import ScreenTemplate from "../patterns/screenTemplate";

const PageNotFound = () => {
  return (
    <ScreenTemplate>
      <div className="tutorials_screen">Oops! 404 page not found.</div>
    </ScreenTemplate>
  );
};

export default PageNotFound;
